import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_col(walkedNode) {

  supplyEventInAction(walkedNode)
}
